// import { useState } from "react";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
// import {Route, Link} from "react-router-dom";

import {
  BrowserRouter,
  Routes, // Just Use Routes instead of "Switch"
  Route
} from "react-router-dom";

import "./App.css";

import Home from "./components/Pages/Home";
import SignUp from "./components/Auth/SignUp";
import LoginUser from "./components/Auth/User/LoginUser";
import LoginAdmin from "./components/Auth/Admin/LoginAdmin";
import UserForgotPassword from "./components/Auth/User/ForgotPwsUser.js";
import UserResetPassword from "./components/Auth/User/ResetPwsUser.js";
import Contact from "./components/Pages/Contact";
import PageNotFound from "./components/Pages/PageNotFound.js";

// ADMIN
import AddCustomer from "./components/Admin/AddCustomer";
import AddCompany from "./components/Admin/AddCompany";
import AdminMenu from "./components/Admin/AdminMenu";
import AdminTransactions from "./components/Admin/Transactions";
import AdminUsers from "./components/Admin/Users";

// APP
// onglet offres de ressources
import OffersList from "./components/App/Offers/UserOffersList.js";
import AddNewOffer from "./components/App/Offers/AddNewOffer/AddNewOffer.js";
import NewOfferRecap from "./components/App/Offers/AddNewOffer/AddNewOfferPreview.js";
import EditOfferBeforePublication from "./components/App/Offers/AddNewOffer/EditOfferBeforePublication";
import PublishedOffer from "./components/App/Offers/PublishedOffer.js";
import EditOffer from "./components/App/Offers/EditOffer/EditOffer";

// Recherche
import AllOffersList from "./components/App/Research/AllOffersList.js"

// Favoris
import FavOffersList from "./components/App/Favorites/FavOffers.js";

// Messages
import ConversationsList from "./components/App/Messages/List.js";
import ChatPage from "./components/App/Messages/Chatpage.js";

// Profil
import ProfileMenu from "./components/App/Profile/ProfileMenu";
import UserAccount from "./components/App/Profile/Account/AccountInfo";
import ModifyMyAccount from "./components/App/Profile/Account/EditAccountInfo";
import ChangePsw from "./components/App/Profile/Parameters/ChangePassword";
import Disclaimer from "./components/App/Profile/Disclaimer/Disclaimer.js";
import ContactAppForm from "./components/App/Profile/Contact/Contact";
import SalesAndPurchasesLists from "./components/App/Profile/SalesAndPurchases/Status.js";

// Offre
import OfferCard from "./components/Constants/OfferCard.js";

// Payment
import PaymentSucceed from "./components/App/Payment/Succeed.js";
import PaymentCanceled from "./components/App/Payment/Canceled.js";
import SetupCard from "./components/App/Payment/SetupCard.js";

const App = () => {
  // const [id, setId] = useState(null);

  return (
    <MantineProvider>
      <ModalsProvider>
        <div className="useRoboto">
          {/* <Navbar></Navbar> */}
          <BrowserRouter>
            <Routes>
              {/* AUTH */}
              <Route path="/" element={<Home />} />
              <Route path="/app/forgot-password" element={<UserForgotPassword />} />
              <Route path="/app/reset-password" element={<UserResetPassword />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/app/login" element={<LoginUser />} />
              <Route path="/adm/login" element={<LoginAdmin />} />
              <Route path="/contact" element={<Contact />} />

              {/* ADMIN */}
              <Route path="/adm/addcust" element={<AddCustomer />} />
              <Route path="/adm/addcomp" element={<AddCompany />} />
              <Route path="/adm/menu" element={<AdminMenu />} />
              <Route path="/adm/transactions" element={<AdminTransactions />} />
              <Route path="/adm/users" element={<AdminUsers />} />
              
              {/* APP */}
              <Route path="/app/offer-card" element={<OfferCard />} />
              
              {/* Offre de ressource */}
              <Route
                path="/app/offers/list"
                element={<OffersList />}
              />
              <Route path="/app/offers/add" element={<AddNewOffer />} />
              <Route
                path="/app/offers/add-preview/:id"
                element={<NewOfferRecap />}
              />
              <Route
                path="/app/offers/preoffer-edit/:id"
                element={<EditOfferBeforePublication />}
              />
              <Route path="/app/offers/offer/:id" element={<PublishedOffer />} />
              <Route path="/app/offers/offer-edit/:id" element={<EditOffer />} />
             
              {/* Research */}
              <Route path="/app/research/list" element={<AllOffersList />} />
              
              {/* Favoris */}
              <Route path ="/app/fav/list" element={<FavOffersList />} />

              {/* Messages */}
              <Route path ="/app/msg/list" element={<ConversationsList />} />
              <Route path="/app/msg/chat/:conversationId" element={<ChatPage />} />             
              
              {/* Payment */}
              <Route path='/app/payment/succeed' element={<PaymentSucceed />} />
              <Route path='/app/payment/canceled' element={<PaymentCanceled />} />
              <Route path='/app/payment/setup-card' element={<SetupCard />} /> 
              
              {/* Menu profil */}
              <Route path="/app/profile/menu" element={<ProfileMenu />} />
              <Route path="/app/profile/account" element={<UserAccount />} />
              <Route path="/app/profile/edit" element={<ModifyMyAccount />} />
              <Route
                path="/app/profile/param/psw-edit"
                element={<ChangePsw />}
              />
              <Route
                path="/app/profile/disclaimer"
                element={<Disclaimer />}
              />
              <Route path="/app/profile/contact" element={<ContactAppForm />} />
              <Route path="/app/profile/orders" element={<SalesAndPurchasesLists />} />

            
              <Route
                    path="*"
                    element={<PageNotFound />}
                />

            </Routes>
          </BrowserRouter>
          {/* <Footer></Footer> */}
        </div>
      </ModalsProvider>
    </MantineProvider>
  );
};

export default App;
